import React, { useCallback, useMemo } from 'react';
import classnames from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Text, TextType } from 'ui-components/components/text';
import { GuidService } from 'ui-components/services/guid-service';

import style from './weight.module.less';
import { UnitDisplayType } from '../../../../enums/units/unit-display-type';
import { UnitPosition } from '../../../../enums/units/unit-position';
import { WeightUnit } from '../../../../enums/weight-unit';
import WeightLabel from '../../../../fulfillment-planner/weight/label';
import Scale from '../../../../fulfillment-planner/weight/scale';
import messages from '../../../../orders/order-details/fulfillment-plan/sections/configure-shipment/messages';
import { WeightPropType } from '../../../../prop-types/weight';
import * as PresetActions from '../../../../store/seller/presets/seller.presets.actions';
import { ConvertedWeightInput } from '../../../converted-weight-input/converted-weight-input';
import { weight as weightPresetName } from '../../constants';

import buttonTextStyle from 'ui-components/components/button/button-text.module.less';

const WeightPresetOption = ({ onChange, data = {} }) => {
  const dispatch = useDispatch();

  const weight = useMemo(() => {
    return { weight: data.value || 0, weightUnit: data.unit || WeightUnit.Ounces };
  }, [data.value, data.unit]);

  const onWeightChange = useCallback(
    (value, unit) => {
      onChange({ name: weightPresetName, value: { value, unit } });
    },
    [onChange],
  );

  const onReadFromScale = useCallback(
    (scale) => {
      dispatch(PresetActions.readFromScale(scale, GuidService.newGuid(), onWeightChange));
    },
    [dispatch, onWeightChange],
  );

  return (
    <>
      <Text textType={TextType.Label} value={<WeightLabel />} />
      <div className={style.weight}>
        <ConvertedWeightInput
          className={style['weight-inputs-outer-container']}
          onChange={onWeightChange}
          unitDisplayType={UnitDisplayType.Abbreviated}
          unitPosition={UnitPosition.InsideStart}
          weight={weight}
          weightInputInnerContainerClassName={style['weight-inputs-inner-container']}
        />
        <Scale
          buttonClassName={classnames(style['scale-button'], buttonTextStyle['button-text'])}
          buttonIconClassName={style['scale-icon']}
          buttonText={<FormattedMessage {...messages.scale} />}
          onReadFromScale={onReadFromScale}
        />
      </div>
    </>
  );
};

WeightPresetOption.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: WeightPropType.isRequired,
};

export default WeightPresetOption;
